import { useEffect } from 'react'

export const useHideAddressBar = () => {
  useEffect(() => {
    const hideAddressBar = () => {
      // iOS Safari에서만 실행
      if (!/iPhone|iPad|iPod/.test(navigator.userAgent)) {
        return
      }

      // 사용자가 스크롤하지 않았을 때만 실행
      if (window.scrollY === 0) {
        setTimeout(() => {
          window.scrollTo(0, 1)
          setTimeout(() => {
            window.scrollTo(0, 0)
          }, 0)
        }, 100)
      }
    }

    const handleResize = () => {
      // viewport 높이가 변경되면 주소창이 숨겨진 것으로 간주
      hideAddressBar()
    }

    const handleOrientationChange = () => {
      setTimeout(hideAddressBar, 100)
    }

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        hideAddressBar()
      }
    }

    // 초기 실행
    hideAddressBar()

    // 이벤트 리스너 등록
    window.addEventListener('resize', handleResize)
    window.addEventListener('orientationchange', handleOrientationChange)
    document.addEventListener('visibilitychange', handleVisibilityChange)

    // 정리
    return () => {
      window.removeEventListener('resize', handleResize)
      window.removeEventListener('orientationchange', handleOrientationChange)
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])
}